import React from 'react';

export const CoverIcon = React.memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g id="Icon / PictureFilled">
        <path
          id="Vector"
          d="M21.75 3.75H2.25C1.83516 3.75 1.5 4.08516 1.5 4.5V19.5C1.5 19.9148 1.83516 20.25 2.25 20.25H21.75C22.1648 20.25 22.5 19.9148 22.5 19.5V4.5C22.5 4.08516 22.1648 3.75 21.75 3.75ZM7.92188 7.125C8.74922 7.125 9.42188 7.79766 9.42188 8.625C9.42188 9.45234 8.74922 10.125 7.92188 10.125C7.09453 10.125 6.42188 9.45234 6.42188 8.625C6.42188 7.79766 7.09453 7.125 7.92188 7.125ZM19.9664 17.3695C19.9323 17.3982 19.8891 17.414 19.8445 17.4141H4.15312C4.05 17.4141 3.96562 17.3297 3.96562 17.2266C3.96562 17.182 3.98203 17.1398 4.01016 17.1047L8.00156 12.3703C8.06719 12.2906 8.18672 12.2812 8.26641 12.3469C8.27344 12.3539 8.28281 12.3609 8.28984 12.3703L10.6195 15.1359L14.325 10.7414C14.3906 10.6617 14.5102 10.6523 14.5898 10.718C14.5969 10.725 14.6062 10.732 14.6133 10.7414L19.9945 17.107C20.0555 17.1844 20.0461 17.3039 19.9664 17.3695Z"
          fill="black"
          fillOpacity="0.45"
        />
      </g>
    </svg>
  );
});

export default CoverIcon;
